<glxy-form-field [bottomSpacing]="bottomSpacing">
  <glxy-label>{{ label }}</glxy-label>
  <mat-chip-grid
    #chipList
    (click)="openAutocomplete()"
    matAutocompleteOrigin
    #origin="matAutocompleteOrigin"
    [formControl]="formControl"
  >
    @for (val of value; track val; let i = $index) {
      @if (getOptionLabelFromValue(val); as optionLabel) {
        <mat-chip-row [disabled]="disabled">
          {{ optionLabel }}
          @if (!disabled) {
            <button matChipRemove [attr.aria-label]="'remove'" (click)="remove(i)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-chip-row>
      }
    }

    <label [ngClass]="{ 'placeholder-space': placeholder }">
      @if (placeholder) {
        <div class="ghost-label">{{ placeholder }}</div>
      }
      <input
        #searchInput
        [matChipInputFor]="chipList"
        [attr.maxlength]="customTagLength"
        [required]="required"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [matAutocomplete]="auto"
        [matAutocompleteConnectedTo]="origin"
        (input)="inputTerm.next(searchInput.value)"
      />
    </label>
  </mat-chip-grid>
  @if (hint || underMinFields || maxFields) {
    <div class="text-and-count">
      <div class="text">
        <glxy-hint>
          {{ hint }}
        </glxy-hint>
        @if (formControl.touched && overMaxFields) {
          <glxy-error>
            {{ 'FRONTEND.FORMS.INPUT.MAX_LENGTH_ERROR' | translate: { maxLength: maxFields } }}
          </glxy-error>
        }
        @if (formControl.touched && underMinFields) {
          <glxy-error>
            {{ 'FRONTEND.FORMS.INPUT.REQUIRED' | translate }}
          </glxy-error>
        }
      </div>
      @if (maxFields) {
        <glxy-hint align="right" class="count">{{ (value || []).length }}/{{ maxFields }}</glxy-hint>
      }
    </div>
  }

  <mat-autocomplete #auto="matAutocomplete">
    @if (loading && !searchInput.value) {
      <span>
        <mat-option class="stencil-shimmer" [disabled]="true"></mat-option>
      </span>
    } @else {
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option.value" (onSelectionChange)="add($event)" (onEnter)="add(option)">
          <span>{{ option.name }}</span>
        </mat-option>
      }
    }
  </mat-autocomplete>
</glxy-form-field>
